import React from 'react'
import styles from '../../styles/modules/components/SelfServe/selfserve-modal.module.scss';
import commonStyles from '../../styles/modules/components/SelfServe/phone-input-step.module.scss';
import Button from '../common/ui-components/input/Button';
import UIModal from '../common/ui-components/surface/UIModal';
import {changeProgress} from '../../redux/actions/selfserveActions';
import { useDispatch } from 'react-redux';
import { Hidden } from '@mui/material';
import warning from "../../public/static/images/warning.png"
import Image from '../common/Image';


interface MainProps{
    closeModal: any,
    is_open: boolean,
    confirm: Function

}
const CopayAfterSrConfirmationAlert = (props: MainProps) => {

    const dispatch:any = useDispatch();
    const close = () => {
            props.closeModal(false)
    }
    const proceed = () => {
        props.confirm()
        props.closeModal(false)
    }
    return (
        <UIModal isOpen={props.is_open} onClick={close} larger={false} boxClass={styles.apply_box}>
            <div className={styles.selfserve_alert}>
                <div className={styles.sales_selfserve_alert__content}>
                <div className={styles.selfserve_alert__icon}>
                <Image src="/static/images/warning.png" width={30} height={30} alt="warning" className={styles.warning_icon}/>
                <h5 className={styles.selfserve_alert__title}>Important</h5>
                </div>

                <p>The Service will start only after the customer pays the co-payment.</p>
                </div>
        
                
            
                <Hidden smUp>
                    <div className={commonStyles.single_button} style={{'marginTop' : "0"}}>

                        <Button
                            onClick={proceed}
                            text="Confirm"
                            className={commonStyles.single_btn}
                            style={{'fontSize': '14px'}}
                        />

                        <Button
                            onClick={close}
                            text="Cancel"
                            variant="secondary"
                            className={commonStyles.single_btn}
                            style={{'fontSize': '14px'}}
                        />
                    </div>
                </Hidden>

                <Hidden smDown>
                    <div className={commonStyles.button_actions_sticky} data-varient='non-sticky' style={{'marginBottom': '40px', 'marginTop' : "20px"}}>

                        <Button
                            onClick={close}
                            text="Cancel"
                            variant="secondary"
                            className={commonStyles.cart_btn}
                            style={{'fontSize': '14px'}}
                        />
                        <Button
                            onClick={proceed}
                            text="Confirm"
                            className={commonStyles.cart_btn}
                            style={{'fontSize': '14px'}}
                        />
                    </div>
                </Hidden>
            </div>

        </UIModal>
    );
}

export default CopayAfterSrConfirmationAlert